import { media, TertiaryButton } from 'ia-react-core';
import styled from 'styled-components';

export const StyledButton = styled(TertiaryButton)`
  display: inline-block;
  margin-top: 12px;
  ${media.sm`
    display: none;
  `}
`;
